// @ts-nocheck
import React, { useState } from 'react'
import Link from 'next/link'
import { useSelector, useDispatch } from 'react-redux'
import { useRouter } from 'next/router'

import { forgotPassword } from 'actions'
import { Button } from 'components/common'
import s from './ForgotPassword.module.css'

const ForgotPassword = () => {
  const { isLoading } = useSelector((state) => state.forgotPassword)

  const [emailInput, setEmailInput] = useState()

  const dispatch = useDispatch()

  const router = useRouter()

  const forgotPasswordHandler = (e) => {
    e.preventDefault()

    dispatch(forgotPassword(emailInput, () => router.push('/login')))
  }

  return (
    <div className="content">
      <form className={s.form} onSubmit={forgotPasswordHandler}>
        <h3 className={s.forgotPasswordText}>Forgot your password?</h3>

        <div className={s.enterEmailText}>
          Please enter your e-mail address and we'll send you a verification
          e-mail.
        </div>

        <input
          type="email"
          value={emailInput}
          onChange={(e) => setEmailInput(e.target.value)}
          className={s.input}
          placeholder="E-mail"
          required
        />

        <Button
          text="SEND MAIL"
          onClick={forgotPasswordHandler}
          isLoading={isLoading}
        />

        <Link href="/login">
          <a className={s.goBack}>I remember my password. Go back</a>
        </Link>
      </form>
    </div>
  )
}

export default ForgotPassword
